import { PaperBlock } from './paper-block'
import { Quiz } from './quiz'

export interface QuizReflectionBlockQuestionInterface {
  blocks?: PaperBlock[]
  quiz?: Quiz
  /**
   * 开始作答时间
   */
  startAt: string
  /**
   * 满分
   */
  fullScore: string
  /**
   * 倒计时-时分秒
   */
  countdown?: number
  bizId?: number
}

export class QuizReflectionBlockQuestion
  implements QuizReflectionBlockQuestionInterface
{
  blocks?: PaperBlock[]
  quiz?: Quiz
  /**
   * 开始作答时间
   */
  startAt: string
  /**
   * 满分
   */
  fullScore: string
  /**
   * 倒计时-时分秒
   */
  countdown?: number
  bizId?: number

  constructor(props: QuizReflectionBlockQuestionInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      blocks: _blocks,
      quiz: _quiz,
      startAt: _startAt,
      fullScore: _fullScore,
      countdown: _countdown,
      bizId: _bizId,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.blocks = _blocks ? _blocks.map((i) => new PaperBlock(i)) : _blocks
    this.quiz = _quiz ? new Quiz(_quiz) : _quiz
    this.startAt = _startAt
    this.fullScore = _fullScore
    this.countdown = _countdown
    this.bizId = _bizId
  }
}
